import { translate } from "game/translate"
import { useCallback, useLayoutEffect, useRef } from "react";
import { useFeedBackFormSubmitter } from "./useFeedBackFormSubmitter";

import "./styles.css";
import { GameUI } from "game/gameUI/GameUI";
import { Popups } from "ui/types/popups";

export const FeedBack = () => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const submitButtonRef = useRef<HTMLButtonElement>(null);
    const screenResInputRef = useRef<HTMLInputElement>(null);

    const onFormSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        useFeedBackFormSubmitter(textareaRef.current, submitButtonRef.current, screenResInputRef.current)(event);
    }, [textareaRef.current, submitButtonRef.current, screenResInputRef.current]);

    const updatreSubmitBtn = () => {
        const textarea = textareaRef.current;
        const submitButton = submitButtonRef.current;
        let status = false;
        
        if (textarea && textarea.value.length < 5) {
            status = true;
        }
        if (submitButton) {
            submitButton.disabled = status;
        }
    }

    const handleDiscardBtnClick = () => {
        GameUI.closePopup(Popups.FEEDBACK_POPUP);
    }

    useLayoutEffect(() => {
        updatreSubmitBtn();
    }, []);

    return (
        <div id="feedback" role="tooltip" className="feedback_body modals_area active">
            <img loading="lazy" className="feedback_cards" src="/assets/feedback/feedback_cards.webp" alt= "cards" />
            <div  className="feedback">
                <div className="wrapper">
                    <div className="text_content">
                        <span className="modals_area-title">{translate("feedback_title_1")} <span className="green_text">{translate("feedback_title_2")}</span></span>
                        <p className="modals_area-text">{translate("feedback_text")}</p>
                        <div className="form_wrap">
                            <form id="feedbackForm" method="post" action="" onSubmit={onFormSubmit}>
                                <textarea ref={textareaRef} id="feedBackArea" maxLength={500} className="textarea" required onInput={updatreSubmitBtn} placeholder={translate("feedback_field_text")}></textarea>
                                <div className="feedback_btn-wrap">
                                    <button type="button" className="discard_btn close" onClick={handleDiscardBtnClick}>{translate("discard_btn_text")}</button>
                                    <button ref={submitButtonRef} type="submit" id="feedBackBtn" className="modals_area-btn-submit">
                                        {translate("feedback_btn_text")}
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    </button>
                                    <input type="hidden" name="check" value="wkhcvhkjwvcjhvewhjc"/>
                                    <input ref={screenResInputRef} type="hidden" name="screen_resolution" id="screen_resolution"/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}